/*
 * @bot-written
 *
 * WARNING AND NOTICE
 * Any access, download, storage, and/or use of this source code is subject to the terms and conditions of the
 * Full Software Licence as accepted by you before being granted access to this source code and other materials,
 * the terms of which can be accessed on the Codebots website at https://codebots.com/full-software-licence. Any
 * commercial use in contravention of the terms of the Full Software Licence may be pursued by Codebots through
 * licence termination and further legal action, and be required to indemnify Codebots for any loss or damage,
 * including interest and costs. You are deemed to have accepted the terms of the Full Software Licence on any
 * access, download, storage, and/or use of this source code.
 *
 * BOT WARNING
 * This file is bot-written.
 * Any changes out side of "protected regions" will be lost next time the bot makes any changes.
 */
import * as React from 'react';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import { observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { getFrontendNavLinks } from 'Views/FrontendNavLinks';
import Navigation, { Orientation } from 'Views/Components/Navigation/Navigation';

// % protected region % [Add any extra imports here] on begin
import { Redirect, Route, Switch } from 'react-router';
import Project from "../Components/Project/Project";
import ReviewOrder from '../Components/Order/ReviewOrder';
import PurchaseOrder from "../Components/Order/PurchaseOrder";

interface IProjectRouteProps {
	pid: string,
	tab?: string,
	oid?: string, 
}
// % protected region % [Add any extra imports here] end

export interface ProjectPageProps extends RouteComponentProps {
	// % protected region % [Add any extra props here] off begin
	// % protected region % [Add any extra props here] end
}

@observer
// % protected region % [Add any customisations to default class definition here] off begin
class ProjectPage extends React.Component<ProjectPageProps> {
// % protected region % [Add any customisations to default class definition here] end

	// % protected region % [Add class properties here] on begin
	private projectView = (pageProps: RouteComponentProps<IProjectRouteProps>) => {
		
		const { pid, tab } = pageProps.match.params;
		
		return(
			<Project {...this.props} projectId={pid} defaultTab={tab} />
		); 
	};

	private cartPage = (pageProps: RouteComponentProps<IProjectRouteProps>) => {
		const { pid } = pageProps.match.params;

		return <ReviewOrder projectId={pid} />
	};
	// % protected region % [Add class properties here] end

	render() {
		// % protected region % [Add logic before rendering contents here] off begin
		// % protected region % [Add logic before rendering contents here] end

		let contents = (
			<SecuredPage groups={['Super Administrators', 'AptusAdmin', 'User']}>
				{
				// % protected region % [Alter navigation here] off begin
				}
				<Navigation
					linkGroups={getFrontendNavLinks(this.props)}
					orientation={Orientation.VERTICAL}
					match={this.props.match}
					location={this.props.location}
					history={this.props.history}
					staticContext={this.props.staticContext}
				/>
				{
				// % protected region % [Alter navigation here] end
				}
				<div className="body-content">
					{
					// % protected region % [Add code for 1ee45131-7cb7-47ef-9d55-94f0c0be37cc here] on begin
					}
					<Switch>
						<Route path={`${this.props.match.url}/:pid/cart`} render={this.cartPage} />
						<Route path={`${this.props.match.url}/:pid/:tab?`} render={this.projectView} />
						<Redirect to={'/dashboard'} />
					</Switch>
					{
					// % protected region % [Add code for 1ee45131-7cb7-47ef-9d55-94f0c0be37cc here] end
					}
				</div>
			</SecuredPage>
		);

		// % protected region % [Override contents here] off begin
		// % protected region % [Override contents here] end

		return contents;
	}
}

// % protected region % [Override export here] off begin
export default ProjectPage;
// % protected region % [Override export here] end
